export const layout_names = {
  public: 'public',
  authorization: 'authorization',
  dashboard: 'dashboard',
}